import React from "react";
import { motion } from "framer-motion";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";
import { fadeUp, viewport } from "@/lib/motion";
import { FAQ } from "@/data/smartContainer";
import SectionHeader from "./SectionHeader";

export default function FaqSection() {
  return (
    <section id="faq" className="py-24 sm:py-32 bg-slate-50/60 border-y border-slate-200/70" data-testid="faq-section">
      <div className="dm-container">
        <SectionHeader
          eyebrow="FAQ"
          title="Questions about the model, answered."
          description="How SmartContainer™ works, what DeMaxtore does, and what it never does."
        />
        <motion.div variants={fadeUp} initial="hidden" whileInView="visible" viewport={viewport}
          className="mt-14 max-w-3xl mx-auto">
          <Accordion type="single" collapsible className="space-y-3" data-testid="faq-accordion">
            {FAQ.map((item, i) => (
              <AccordionItem key={i} value={`item-${i}`}
                className="dm-card border-0 px-6 data-[state=open]:ring-1 data-[state=open]:ring-blue-500/15"
                data-testid={`faq-item-${i}`}>
                <AccordionTrigger className="py-5 text-base font-semibold text-slate-900 hover:no-underline">{item.q}</AccordionTrigger>
                <AccordionContent className="pb-5 text-sm text-slate-500 leading-relaxed">{item.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
}
